import { render } from "./TopLeftMenu.vue?vue&type=template&id=737def63&ts=true"
import script from "./TopLeftMenu.vue?vue&type=script&lang=ts"
export * from "./TopLeftMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__